export class UserLoginInfoDto{
    MailAdress: string;
    Password: string;
    NewPassword: string;
    ConfirmPassword: string;
    PassReissueKey: string;
    Url: string;
    Language: string;
    HTOrgCode: string;
    SavePass = false;
    ConsulID: string;
    UserID: string;
}
